import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayDeleteEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayDeleteEventDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandOverlayDeleteEvent) {
    JsonSchemaValidator.assert(RoomBrandOverlayDeleteEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomBrandOverlayDeleteEvent {
  roomId: RoomId;
}
